import React from 'react';
import { withRouter } from 'react-router';
import { PageHeader } from '../../components/admin/Shared';
import RegisterSection, {
  RegistrationProps,
} from '../../components/RegisterSection';

function AdminUsersCreateComponent(props: RegistrationProps): JSX.Element {
  return (
    <>
      <PageHeader
        title="Users Create"
        onBack={() => props.history.push('/admin/users')}
      />
      <RegisterSection
        {...props}
        postRegistration={() => {
          props.history.push('/admin/users');
        }}
        path="/users/create"
        createAdminAccount={true}
      />
    </>
  );
}

export default withRouter(AdminUsersCreateComponent);
